<template>
  <el-menu :default-active="$route.path" :unique-opened="true" :router="true">
    <el-menu-item index="/member">
      <i class="el-icon-user"></i>
      <span slot="title">会员中心</span>
    </el-menu-item>
    <el-menu-item index="1" route="/" @click="toMember()">
      <i class="el-icon-setting"></i>
      <span slot="title">店铺后台</span>
    </el-menu-item>
	<!-- <el-menu-item index="/expert" >
	  <i class="el-icon-reading"></i>
	  <span slot="title">专家文库</span>
	</el-menu-item>	 -->
	<!--  -->
	<el-submenu index="2" v-if="zj_state != null || zj_state != 3 || zj_state != 4 && this.ishop != 1">
	  <template slot="title">
	    <i class="el-icon-reading"></i>
	    <span>专家文库</span>
	  </template>
	  <el-menu-item-group>
	<el-menu-item index="/expert">专家信息</el-menu-item>
	    <el-menu-item index="/expertList">专家文库</el-menu-item>
	  </el-menu-item-group>
	</el-submenu>
	<!--  -->
    <el-menu-item index="3" route="/" @click="loc('/Home-Cart-cart.html')">
      <i class="el-icon-shopping-cart-1"></i>
      <span slot="title">我的购物车</span>
    </el-menu-item>
    <el-submenu index="4">
      <template slot="title">
        <i class="el-icon-shopping-bag-1"></i>
        <span>采购中心</span>
      </template>
      <el-menu-item-group>
		<el-menu-item index="/purchased">已购买采购</el-menu-item>
        <el-menu-item index="/caigou">采购信息管理</el-menu-item>
        <el-menu-item index="/add_caigou">发布采购信息</el-menu-item>
        <el-menu-item index="/caigou_money">采购报价管理</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-menu-item index="/per_order">
      <i class="el-icon-document"></i>
      <span slot="title">我的订单</span>
    </el-menu-item>
    <el-submenu index="5">
      <template slot="title">
        <i class="el-icon-wallet"></i>
        <span>资产</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/myAssets">我的资产</el-menu-item>
        <!-- <el-menu-item index="/getCash">提现/转出</el-menu-item> -->
        <!-- <el-menu-item index="/">余额收支明细</el-menu-item> -->
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="6">
      <template slot="title">
        <i class="el-icon-coin"></i>
        <span>积分</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/per_jifen">我的积分</el-menu-item>
        <el-menu-item index="/jf_shop">积分商城</el-menu-item>
        <el-menu-item index="/jf_recharge">积分充值</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-submenu index="7">
      <template slot="title">
        <i class="el-icon-folder-add"></i>
        <span>我的收藏</span>
      </template>
      <el-menu-item-group>
        <el-menu-item index="/per_shopsc">收藏的店铺</el-menu-item>
        <el-menu-item index="/per_goodssc">收藏的宝贝</el-menu-item>
      </el-menu-item-group>
    </el-submenu>
    <el-menu-item index="8" disabled>
      <i class="el-icon-truck"></i>
      <span slot="title">退款退货</span>
    </el-menu-item>
    <el-menu-item index="/per_buy">
      <i class="el-icon-mouse"></i>
      <span slot="title">我的足迹</span>
    </el-menu-item>
  </el-menu>
</template>

<script>
  export default {
    name: 'aside',
	data() {
	  return {
		  zj_state:localStorage.getItem("zj_state"),
		  shop:localStorage.getItem("ishop"),
	  }
	},
    methods: {
      loc(url) {
        window.location.href = url;
      },
      toMember() {
		window.location.href="/Myseller-Index-index.html"
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/wrap/Asid.vue